import Button from 'components/button';
import styles from './styles.module.scss';
import useDeleteFavoriteList from 'api/hooks/use-favorite-list-delete';
import { EFavoritesType } from 'lib/types';
import { FavouritesType } from 'lib/dictionary';

interface IRejectionFavoriteListForm {
  onClose: () => void;
  id: number;
  refetchList: () => void;
  type: EFavoritesType;
  title: string;
  isOwner: boolean;
}

const DeleteFavoriteListForm = ({
  onClose,
  refetchList,
  id,
  type,
  title,
  isOwner,
}: IRejectionFavoriteListForm) => {
  const typeDelete = isOwner ? 'delete' : 'leave';

  const { isMutating, trigger } = useDeleteFavoriteList(id, typeDelete);

  const handleDeleteFavoriteList = async () => {
    if (id) {
      await trigger();
      refetchList();
      onClose();
    }
  };

  return (
    <div className={styles.containerBottomSheet}>
      <p className={styles.title}>{`Вы уверены что хотите удалить ${FavouritesType.label(
        type,
      )} список '${title}'?`}</p>
      <div className={styles.btnFlex}>
        <Button variant='gray' label='отмена' onClick={onClose} />
        <Button label='удалить' loading={isMutating} onClick={handleDeleteFavoriteList} />
      </div>
    </div>
  );
};

export default DeleteFavoriteListForm;
